import DatePicker, { IDatePickerProps } from '../datePicker';
import { IValidationPredicate, IValidator, useStateRef } from 'copyright-clearance-center-common-ui-react';
import React from 'react';

export interface IDatePickerHookProps extends IDatePickerProps {
	validationPredicate: IValidationPredicate<Date | undefined>;
}

export type DatePickerControlHook = [
	JSX.Element,
	Date | undefined,
	(value: Date | undefined) => void,
	IValidator,
	React.MutableRefObject<Date>
];

const useDatePicker = (props: IDatePickerHookProps): DatePickerControlHook => {
	const [value, setValue, valueRef] = useStateRef<Date | undefined>(props.value);
	const [error, setError] = React.useState<string | undefined>(props.error);
	const enrichedProps: IDatePickerHookProps = {
		...props,
		value,
		error,
		onDateChanged: date => {
			if (date?.getTime() === valueRef.current?.getTime()) {
				return;
			}

			setError('');
			setValue(date);
			props.onDateChanged?.call(control, date);
		}
	};
	const control = <DatePicker {...enrichedProps} />;

	return [
		control,
		value,
		setValue,
		() => props.disabled || props.validationPredicate(valueRef.current, setError),
		valueRef
	];
};

export default useDatePicker;
